<form [formGroup]="form" class="example-form">
  <div class="row">
    <div class="mb-2" *ngFor="let field of renderFormField" [ngClass]="getColumn(field.controlType, field.classCss)">
      <app-form-input [field]="field" [form]="form"></app-form-input>
    </div>
  </div>
</form>
